<template>
  <md-dialog :md-active="showDialog" class="dialogClass">
    <form @submit.prevent="savePolicy" class="md-scrollbar bodyFrom">
      <h5 class="dialogHeader">
        <i class="fas fa-info-circle"></i> Chính sách cộng tác viên
      </h5>
      <div class="bodyDialog md-layout">
        <div class="md-layout-item">
          <md-field>
            <md-textarea
              v-model="policyPartners"
              placeholder="Nhập chính sách cho cộng tác viên"
              :md-autogrow="true"
            ></md-textarea>
          </md-field>
        </div>
      </div>
      <h5 class="dialogHeader"><i class="fas fa-link"></i> Link đính kèm</h5>
      <div class="bodyDialog md-layout">
        <div class="md-layout-item">
          <md-field>
            <md-input
              v-model="link"
              placeholder="Nhập link đính kèm"
            ></md-input>
          </md-field>
        </div>
      </div>
      <h5 class="dialogHeader">
        <i class="far fa-star"></i> Hạng cộng tác viên
      </h5>
      <div class="bodyDialog" v-for="(item, index) in listRank" :key="index">
        <div class="iconRemove clickable" @click="removeRank(index)">
          <i class="fas fa-times clickable"></i>
        </div>
        <div class="md-layout">
          <div class="md-layout-item">
            <md-field>
              <label>Tiêu đề</label>
              <md-input v-model="item.label" required></md-input>
            </md-field>
          </div>
          <div class="md-layout-item">
            <md-field :md-clearable="true">
              <label>Tỷ lệ hoa hồng (%)</label>
              <md-input
                v-model="item.affiliateRates"
                pattern="^[0-9].*$"
                title="Chỉ cho phép nhập số"
                :oninput="
                  (item.affiliateRates = parseFloat(item.affiliateRates) || '')
                "
                required
              >
              </md-input>
            </md-field>
          </div>
          <div class="md-layout-item">
            <md-field>
              <label>Ghi chú</label>
              <md-textarea
                v-model="item.note"
                :md-autogrow="true"
              ></md-textarea>
            </md-field>
          </div>
        </div>
      </div>
      <div class="actionDialog">
        <md-button
          class="md-success md-dense md-just-icon md-round"
          @click="addRank"
          style="margin-left: 10px"
        >
          <md-icon>add</md-icon>
          <md-tooltip>Thêm hạng</md-tooltip>
        </md-button>
        <md-dialog-actions>
          <md-button class="md-danger md-dense" @click="closeDialog"
            >đóng</md-button
          >
          <md-button class="md-success md-dense" type="submit">lưu</md-button>
        </md-dialog-actions>
      </div>
    </form>
  </md-dialog>
</template>
<script>
export default {
  props: ["showDialog", "db"],
  data() {
    return {
      policyPartners: "",
      listRank: [
        {
          label: "Hạng 1",
          affiliateRates: 0,
          note: "",
        },
      ],
      link: "",
    };
  },
  // created () {
  //   this.db
  //     .collection('--stats--')
  //     .doc(process.env.VUE_APP_PARTNER_POLICY)
  //     .get()
  //     .then(doc => {
  //       if (doc.exists) {
  //         this.policyPartners = doc.data().policy,
  //         this.listRank = doc.data().listRank
  //       }
  //     });
  // },
  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },
    addRank() {
      this.listRank.push({
        label: "",
        affiliateRates: 0,
        note: "",
      });
    },
    savePolicy() {
      this.$store.dispatch("FLAG_LOADING", true);
      var bits = localStorage.getItem("bits");
      this.db
        .collection("--stats--")
        .doc(process.env.VUE_APP_PARTNER_POLICY + bits)
        .update({
          policy: this.policyPartners,
          listRank: this.listRank,
          link: this.link,
        })
        .then((doc) => {
          this.$store.dispatch("FLAG_LOADING", false);
          this.$messageSuccess("Thành công!!!");
        });
    },
    removeRank(index) {
      this.listRank.splice(index, 1);
    },
  },
  watch: {
    showDialog() {
      var bits = localStorage.getItem("bits");
      this.db
        .collection("--stats--")
        .doc(process.env.VUE_APP_PARTNER_POLICY + bits)
        .get()
        .then((doc) => {
          if (doc.exists) {
            (this.policyPartners = doc.data().policy),
              (this.listRank = doc.data().listRank),
              (this.link = doc.data().link);
          }
        });
    },
  },
};
</script>
<style scoped>
.dialogHeader {
  margin: 10px 10px 0 10px;
  padding-left: 10px;
}
.bodyDialog {
  width: 70vw;
  background: rgba(231, 231, 231, 0.87);
  margin: 10px;
  padding: 0px;
  border-radius: 4px;
}
.iconRemove {
  color: rgb(153, 0, 0);
  border: solid 1px rgb(153, 0, 0);
  border-radius: 50%;
  position: relative;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  float: right;
  /* // top: 10px;
  // right: 10px; */
}
.bodyFrom {
  padding: 10px;
  max-height: 80vh;
  overflow: auto;
}
.actionDialog {
  display: flex;
  justify-content: space-between;
}
</style>
